/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Form, Grid, Header, Icon } from "semantic-ui-react";
import TourLayoutWrapper from "../components/TourLayoutWrapper";
import TourNav from "../constants/TourNav";
import TourStore from "~/stores/TourStore";
import ModalError from "~/components/element/ModalError";
import Clipboard from "../components/Clipboard";
import "../styles/Links.less";
import ContentLoader from "~/components/element/ContentLoader";
import LinkSection, { getIframe } from "./Links/LinkSection";
import QrCodeHelper from "~/utils/QrCodeHelper";

@observer
class Links extends Component {
  constructor(props) {
    super(props);
    document.title = "Tour - Links";
    this.state = {
      address: 1,
      branding: 1,
      links: 1,
      autoplay: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getUrl(baseUrl, customParams = {}) {
    const { address, branding, links, autoplay } = this.state;

    const params = { ...customParams };

    if (autoplay !== null) {
      params.autoplay = autoplay;
    }

    if (address === 1 && branding === 1 && links === 1) {
      params.a = 1;
    } else {
      params._a = address;
      params._b = branding;
      params._l = links;
    }

    const paramsArray = Object.keys(params).map(key => `${key}=${params[key]}`);
    const queryString = paramsArray.join("&");

    return `${baseUrl}?${queryString}`;
  }

  render() {
    const { tourStore, t } = this.props;
    const { address, branding, links, autoplay } = this.state;
    const { isLoading, tour } = tourStore;
    const customTourUrl = this.getUrl(tour.tourUrl);

    if (isLoading) {
      return <ContentLoader />;
    }

    return (
      <>
        <ModalError nestStore={tourStore} />
        <Header as="h2" content={t("tourLinks")} />
        <div className="tour-links-content">
          <LinkSection title={t("brandedTour")} url={tour.brandedTourUrl} />
          <LinkSection title={t("unbrandedTour")} url={tour.idxTourUrl} />
          {tour.matterportUrlBranded && <LinkSection title={t("branded3DTour")} url={tour.matterportUrlBranded} />}
          {tour.matterportUrlUnbranded && (
            <LinkSection title={t("unbranded3DTour")} url={tour.matterportUrlUnbranded} />
          )}
          {tour.shouldDisplayUnbrandedFlyerUrl && (
            <>
              <LinkSection title={t("clientPanelMisc:flyerUrl")} url={tour.brandedFlyerPDFUrl} />
              <LinkSection
                title={t("clientPanelMisc:alternativeFlyerUrl")}
                url={tour.unbrandedFlyerUrlForMlsSettings}
                description={t("clientPanelMisc:alternativeFlyerUrlDescription")}
              />
            </>
          )}
          {tour.canDisplayAsPocketWebsite && (
            <>
              <LinkSection title={t("brandedPocketWebsite")} url={tour.brandedPocketWebsiteURL} />
              <LinkSection title={t("unbrandedPocketWebsite")} url={tour.unbrandedPocketWebsiteURL} />
              <LinkSection title={t("clientPanelMisc:immersive3dTourWithoutDesign")} url={tour.immersive3dTourURL} />
            </>
          )}
          <LinkSection title="Gallery" url={tour.galleryUrl} />
          <div className="tour-links-content-section">
            <h4>{t("clientPanelMisc:customLinkBuilder")}</h4>
            <Form>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <div style={{ display: "inline-block", marginRight: "200px" }}>
                      <Form.Field>
                        <label>{t("showDots")}</label>
                      </Form.Field>
                      <Form.Checkbox
                        checked={!!address}
                        onClick={() => this.setState({ address: address ? 0 : 1 })}
                        label={t("clientPanelMisc:address")}
                      />
                      <Form.Checkbox
                        checked={!!branding}
                        onClick={() => this.setState({ branding: branding ? 0 : 1 })}
                        label={t("branding")}
                      />
                      <Form.Checkbox
                        checked={!!links}
                        onClick={() => this.setState({ links: links ? 0 : 1 })}
                        label={t("clientPanelMisc:links")}
                      />
                    </div>
                    <div style={{ display: "inline-block" }}>
                      <Form.Field>
                        <label>{t("autoPlay")}:</label>
                      </Form.Field>
                      <Form.Radio
                        checked={autoplay === null}
                        onClick={() => this.setState({ autoplay: null })}
                        label={t("default")}
                        name="autoplay"
                      />
                      <Form.Radio
                        checked={autoplay === 1}
                        onClick={() => this.setState({ autoplay: 1 })}
                        label={t("on")}
                        name="autoplay"
                      />
                      <Form.Radio
                        checked={autoplay === 0}
                        onClick={() => this.setState({ autoplay: 0 })}
                        label={t("off")}
                        name="autoplay"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1}>
                  <Grid.Column>
                    <Form.Field className="tour-links-generated-field">
                      <label className="tour-links-generated-label">{t("clientPanelMisc:linkGenerated")}</label>
                    </Form.Field>
                    <a href={customTourUrl}>{customTourUrl}</a>
                    <div className="tour-links-clipboard-wrap">
                      <Clipboard
                        data={customTourUrl}
                        animationTime={2000}
                        contentPopup={t("copyURLClipboard")}
                        hide={isLoading}
                      />
                      <Clipboard
                        data={
                          customTourUrl
                            ? getIframe({ title: t("clientPanelMisc:linkGenerated"), url: customTourUrl })
                            : ""
                        }
                        animationTime={2000}
                        contentPopup={t("copyIframeClipboard")}
                        content={<Icon name="code" color="black" />}
                        hide={isLoading}
                      />
                      <Button
                        style={{ background: "none", marginTop: "-0.55em", marginLeft: "-0.2em" }}
                        size="small"
                        icon
                        as="a"
                        title="Qr"
                        href={QrCodeHelper.makeQueryQrCode(customTourUrl)}
                        floated="right"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Icon name="qrcode" color="black" />
                      </Button>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </div>
        </div>
      </>
    );
  }
}

Links.propTypes = {
  tourStore: PropTypes.instanceOf(TourStore),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourLayoutWrapper(Links, TourNav.LINKS));
